import React from "react";
import Template from "../components/Template";

function TermsAndConditions() {
  return (
    <Template>
      <div className="section-lgx pb-0"></div>
      <section className="section-lgx">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p className="updated-date">Last updated: 7 January 2026</p>
          <p>
            This website, DailyFitZone, is owned and operated by CoachElite, a
            registered fitness and coaching company.
          </p>
          <p>
            Welcome to <strong>Coach Elite</strong> (“we”, “us”, “our”). These
            Terms & Conditions govern your use of our website, services,
            programs, coaching sessions, and digital content (collectively, the
            “Services”).
          </p>

          <p>
            By accessing or using our Services, you agree to be bound by these
            Terms & Conditions. If you do not agree, please do not use our
            Services.
          </p>

          <h5>1. Eligibility</h5>
          <p>
            You must be at least 18 years old to use our Services. If you are
            under 18, you may use the Services only with parental or legal
            guardian consent.
          </p>

          <h5>2. Services</h5>
          <p>
            Coach Elite provides coaching programs, training plans, digital
            content, and related services. All services are offered as-is and
            may be updated, modified, or discontinued at any time without
            notice. Coach Elite does not provide medical, psychological, or
            therapeutic services.
          </p>

          <h5>3. User Responsibilities</h5>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Use the Services only for lawful purposes</li>
            <li>
              Not misuse, copy, or redistribute our content without permission
            </li>
            <li>Respect coaches, trainers, and platform rules</li>
          </ul>

          <h5>4. Payments</h5>
          <ul>
            <li>All prices are displayed clearly before purchase</li>
            <li>Payments must be made in full before accessing services</li>
            <li>We reserve the right to change pricing at any time</li>
            <li>
              Payments are processed through third-party payment gateways. We
              are not responsible for payment failures or technical issues
              caused by these providers.
            </li>
          </ul>
          <br />
          <h5>5. No Refund Policy</h5>
          <p>
            Once a payment is successfully completed, we do not offer refunds
            under any circumstances.
          </p>
          <p>This includes, but is not limited to:</p>
          <ul>
            <li>Change of mind</li>
            <li>Partial use of services</li>
            <li>Missed coaching sessions</li>
            <li>Subscription cancellations</li>
            <li>Dissatisfaction after purchase</li>
            <li>Technical issues from the user’s end</li>
          </ul>
          <p>
            <strong>All payments are final and non-refundable.</strong>
          </p>
          <p>
            By completing a purchase, you acknowledge and agree to this
            no-refund policy.
          </p>

          <h5>6. Cancellation & Termination</h5>
          <ul>
            <li>Suspend or terminate access for violations of these Terms</li>
            <li>
              Restrict users who engage in misuse, abuse, or fraudulent activity
            </li>
          </ul>
          <p>Termination does not entitle the user to any refund.</p>

          <h5>7. Intellectual Property</h5>
          <p>
            All content on this website, including text, graphics, logos,
            videos, programs, and materials, is the intellectual property of
            Coach Elite and may not be copied, reproduced, or distributed
            without written permission.
          </p>

          <h5>8. Disclaimer</h5>
          <p>
            Our coaching services are for educational and informational purposes
            only. We do not guarantee specific results, outcomes, or performance
            improvements.
          </p>
          <p>
            Results may vary based on individual effort, consistency, and
            personal circumstances.
          </p>
          <p>
            Always consult a qualified professional before making health,
            fitness, or lifestyle decisions.
          </p>

          <h5>9. Limitation of Liability</h5>
          <p>
            To the maximum extent permitted by law, Coach Elite shall not be
            liable for:
          </p>
          <ul>
            <li>Any indirect, incidental, or consequential damages</li>
            <li>Loss of data, profits, or business</li>
            <li>
              Personal injury or health issues resulting from use of Services
            </li>
          </ul>
          <p>Use of our Services is at your own risk.</p>

          <h5>10. Third-Party Links</h5>
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for their content, policies, or practices.
          </p>

          <h5>11. Privacy</h5>
          <p>
            Your use of the Services is also governed by our Privacy Policy.
            Please review it to understand how we collect and use your data.
          </p>

          <h5>12. Changes to Terms</h5>
          <p>
            We reserve the right to modify these Terms & Conditions at any time.
            Updates will be posted on this page with a revised date. Continued
            use constitutes acceptance.
          </p>

          <h5>13. Governing Law</h5>
          <p>
            These Terms shall be governed and interpreted in accordance with the
            laws of India, without regard to conflict of law principles.
          </p>

          <h5>14. Contact Information</h5>
          <p>
            For any questions regarding these Terms & Conditions, contact us:
          </p>
          <p>
            <a
              href="mailto:coaching@dailyfitzone.com
"
            >
              coaching@dailyfitzone.com
            </a>
          </p>
        </div>
      </section>
    </Template>
  );
}

export default TermsAndConditions;
